import React from 'react';
import { Box, makeStyles, Theme, createStyles } from '@material-ui/core';
import ArrowChevronLeft from '@jda/lui-common-icon-library/ui/ArrowChevronLeft';
import { useParams, useHistory } from 'react-router';
import ServiceHeader from './ServiceHeader';
import ServiceTabs from './ServiceTabs';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      flexGrow: 1
    },
    icon: {
      color: theme.palette.background.paper,
      cursor: 'pointer'
    },
    header: {
      color: theme.palette.background.paper,
      fontSize: '26px'
    },
    paper: {
      padding: theme.spacing(2),
      textAlign: 'center',
      color: theme.palette.text.secondary
    }
  })
);
interface ServiceProps {
  providerData: providerInfo;
  data: serviceInfo;
}

type providerInfo = {
  [key: string]: any;
};
type serviceInfo = {
  [key: string]: any;
};

const Service = (props: ServiceProps) => {
  const classes = useStyles();
  let { workflowCode } = useParams();
  let history = useHistory();

  const handleClick = () => {
    history.push(`/${window.location.pathname.split('/')[1]}`);
  };
  return (
    <Box px={2} overflow="hidden" width="100%">
      <Box px={1} pt={2} display="flex" alignItems="flex-end">
        <Box>
          <ArrowChevronLeft onClick={handleClick} className={classes.icon} />
        </Box>
        <Box pl={1} className={classes.header}>
          {workflowCode}
        </Box>
      </Box>
      <Box p={1}>
        <ServiceHeader providerData={props.providerData} data={props.data} />
      </Box>
      <Box p={1}>
        <ServiceTabs providerData={props.providerData} data={props.data} workflow={workflowCode} />
      </Box>
    </Box>
  );
};

export default Service;
